'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
const $ = require("jquery");
class Accordion {
    constructor() {
        $('.trigAccordionCourse').on('click', (e) => {
            const isOpen = $(e.currentTarget).attr('data-is-open');
            const faculty = $(e.currentTarget).attr('data-faculty');
            const number = $(e.currentTarget).attr('data-number');
            console.log(isOpen);
            if (isOpen === 'false') {
                $(`.bulletAccordionCourse[data-faculty="${faculty}"][data-number="${number}"]`).stop().slideDown('slow');
                $(e.currentTarget).attr('data-is-open', 'true');
            }
            else {
                $(`.bulletAccordionCourse[data-faculty="${faculty}"][data-number="${number}"]`).stop().slideUp('slow');
                $(e.currentTarget).attr('data-is-open', 'false');
            }
        });
    }
    noScroll(e) {
        e.preventDefault();
    }
}
exports.Accordion = Accordion;
exports.default = Accordion;
